<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/16wYQoh/tc-custom/9780062079015.jpg?1737543861947" alt="This image is the cover for the book Bond"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Bond
      </h1>
      <p class="bookDescription body article font2">
        <p>“If the animals knew about this book they would, without doubt, confer on Wayne Pacelle, their highest honor.”<br/>—Jane Goodall</p><p>“<i>The Bond</i> is the best overall book on animals I have ever read. Brilliant and moving.”<br/>—John Mackey, CEO and Co-founder of Whole Foods Market</p><p>“<i>The Bond</i> is at once heart-breaking and heart-warming. No animal escapes Wayne Pacelle’s attention; nor should his book escape any human animal’s attention.”<br/>—Alexandra Horowitz, <i>New York Times </i>Bestselling Author of <i>Inside of a Dog </i></p><p>The president and CEO of the Humane Society of the United States, the world’s largest animal protection organization, Wayne Pacelle brings us <i>The Bond</i>, a heartfelt, eye-opening exploration of the special bond between animals and humans. With the poignant insight of <i>Animals Make Us Human</i> and the shocking reality of <i>Fast Food Nation</i>—filled with history, valuable insights, and fascinating stories of the author’s experience in the field—<i>The Bond</i> is an important investigation into all the ways we can repair our broken bond with the animal kingdom and a thrilling chronicle of one man’s extraordinary contribution to that effort.<br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Wayne Pacelle
      </h2>
      
      <p class="authorDescription body article"><P>As president and CEO of The Humane Society of the United States (HSUS), Wayne Pacelle leads the largest and most effective animal protection organization and one of the most dominant, high-impact non-profit groups of any kind. Placing special emphasis on transforming public policies and corporate behavior, he has been a primary strategist in securing the enactment of hundreds of state and federal animal-protection laws and helped drive reforms adopted by many of America&#8217;s biggest for-profit companies.&#160; He&#8217;s been named an &#8220;Executive of the Year&#8221; by <I>The Non-Profit Times</I>; a contributor to influential newspapers and magazines, including <I>Foreign Affairs</I>; and author of the <I>New York Times</I> bestseller <I>The Bond: Our Kindship with Animals, Our Call to Defend Them</I>. His blog, <I>A Humane Nation</I>, is published each weekday.&#160; He received his B.A. in history and environmental studies from Yale University in 1987. Pacelle lives in Maryland with his wife Lisa Fletcher, a journalist, and their dog Lily and cat Zoe.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollins
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0a8869f9